import { render, staticRenderFns } from "./RetentionPage.vue?vue&type=template&id=52c2d7b7&"
import script from "./RetentionPage.vue?vue&type=script&setup=true&lang=ts&"
export * from "./RetentionPage.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./RetentionPage.vue?vue&type=style&index=0&id=52c2d7b7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports